import type { Chain } from '@0xtorch/polkadot'
import type { AccountPolkadot } from '@pkg/database-portfolio'
import { retryWith401Handler } from '../utils'

export const getEventIndexes = async (params: {
  account: AccountPolkadot
  chain: Chain
  getToken?: () => Promise<string | null>
}) => {
  const { account, chain, getToken } = params

  return await retryWith401Handler(
    async () =>
      await chain.explorer.getAddressEvents({
        address: account.polkadotAddress,
        fromBlock: (account.polkadotToBlock ?? 0) + 1,
        toBlock: Date.now(),
        createHeaders:
          getToken === undefined
            ? undefined
            : async () => {
                const token = await getToken()
                if (token === null) {
                  return {} as Record<string, string>
                }
                return {
                  Authorization: `Bearer ${token}`,
                }
              },
      }),
  )
}
